import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardWithImage from "./CardWithImage";
import CardsWithText from "./CardsWithText";
import { ShadowBackground, ShadowBackground1 } from "../../../exports/Images";
import { fetchAllSettlementCardsData } from "../../../redux/reducers/apiSlice";
import { selectAuth } from "../../auth/auth.selector";
// import { decryptedText } from "../../../data/DecrytedDatas";

function CardsSettlemets() {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const { settlementCardData } = useSelector((state) => state.api);
  const selectedGym = useSelector((state) => state?.filters?.selectedGym);
  const selectedYear = useSelector((state) => state?.filters?.selectedYear);
  const selectedMonth = useSelector((state) => state?.filters?.selectedMonth);
  const [allCardsStatsData, setAllCardsStatsData] = useState({});

  const selectedGymQueryParam = selectedGym
    ? `&gym_id=${selectedGym?.value}`
    : "";
  const selectedYearParam = selectedYear ? `&year=${selectedYear?.value}` : "";
  const selectedMonthParam = selectedMonth
    ? `&month=${selectedMonth?.value}`
    : "";
  const queryParametersFor = `${selectedGymQueryParam}${selectedYearParam}${selectedMonthParam}`;

  useEffect(() => {
    dispatch(
      fetchAllSettlementCardsData({
        queryParameters: queryParametersFor,
        token: decryptedText?.token,
      })
    );
  }, [queryParametersFor, decryptedText]);

  useEffect(() => {
    if (settlementCardData?.status) {
      setAllCardsStatsData(settlementCardData);
    }
  }, [settlementCardData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <div className="cardsCotaier">
      <CardWithImage
        imageUrl={ShadowBackground}
        title="Total Earnings"
        data={allCardsStatsData?.earnings}
      />
      <CardWithImage
        imageUrl={ShadowBackground1}
        title="CTO"
        data={allCardsStatsData?.cto}
      />
      <CardsWithText
        title="Pending settlement"
        data={allCardsStatsData?.pendingSettlments}
      />
      <CardsWithText
        title="Settlement done"
        data={allCardsStatsData?.SettlmentDone}
      />
    </div>
  );
}

export default CardsSettlemets;
